import { render, staticRenderFns } from "./categories-block.vue?vue&type=template&id=0b5e006e&"
import script from "./categories-block.vue?vue&type=script&lang=js&"
export * from "./categories-block.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports